export enum InputAutocompleteSizes {
  L = 'l',
  M = 'm',
  S = 's',
}

export enum InputAutocompleteColors {
  Gray = 'gray',
  White = 'white',
}

export interface InputAutocompleteItem<T> {
  label: string;
  value: T;
}
